import { baseUrl } from "../utils/baseUrl";
import jwtInterceoptor from "./autorizacao/jwt-interceptor";

class ServicosMotivo {
    create(motivo) {
        return jwtInterceoptor.post(`${baseUrl}/motivo`, motivo)
    }
    listarTodos(){
        return jwtInterceoptor.get(`${baseUrl}/motivo`)
    }
    editar(id, cargo){
        return jwtInterceoptor.put(`${baseUrl}/motivo/${id}`, cargo)
    }
    deletar(id){
        return jwtInterceoptor.delete(`${baseUrl}/motivo/${id}`)
    }
}

export default new ServicosMotivo();